import { render, staticRenderFns } from "./MultipleCatalogSubgroupSelectorTree.vue?vue&type=template&id=2a784f7e&scoped=true&"
import script from "./MultipleCatalogSubgroupSelectorTree.vue?vue&type=script&lang=js&"
export * from "./MultipleCatalogSubgroupSelectorTree.vue?vue&type=script&lang=js&"
import style0 from "./MultipleCatalogSubgroupSelectorTree.vue?vue&type=style&index=0&id=2a784f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a784f7e",
  null
  
)

export default component.exports